import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { getRootDomain, getRegion } from "@util/domain";
import styles from "../NavBar/NavBar.module.css";

const PublicNavBar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const links = [
        { label: "Online Memorials", path: getRootDomain() },
        // Forever Candles ship within Australia only
        ...(getRegion() === "au" ? [{ label: "Forever Candles", path: `${getRootDomain()}/forever-candles` }] : []),
        { label: "Memorial Hub", path: "/" },
        { label: "Our Story", path: `${getRootDomain()}/our-story` },
        { label: "FAQ", path: `${getRootDomain()}/faq` },
        { label: "Contact Us", path: `${getRootDomain()}/contact` },
    ];

    const toggleMenu = () => setIsOpen((prev) => !prev);
    const closeMenu = () => setIsOpen(false);

    return (
        <nav className={styles.navbar}>
            <div className={styles.logo}>
                <a href={getRootDomain()} target="_blank" rel="noopener noreferrer">
                    <img src="/assets/images/fioh-text-logo.png" alt="Logo" className={styles.logoImage} />
                </a>
            </div>
            <button type="button" className={`${styles.hamburger} ${isOpen ? styles.active : ""}`} onClick={toggleMenu}>
                {/* Hamburger icon */}
                <span className={styles.bar} />
                <span className={styles.bar} />
                <span className={styles.bar} />
            </button>
            <ul className={`${styles.nav} ${isOpen ? styles.navOpen : ""}`}>
                {links.map((link) => (
                    <li key={link.path} className={styles.navItem}>
                        <NavLink
                            to={link.path}
                            className={styles.navLink}
                            onClick={closeMenu}
                        >
                            {link.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default PublicNavBar;
